import Dashboard from './screens/Dashboard/Dashboard';
import Login from './screens/Login/Login'
import AccountActivity from './screens/Account Activity/AccountActivity';
import AccountManagement from './screens/Account Management/AccountManagement';
import SubmitExpense from './screens/SubmitExpense/SubmitExpense'
import AccountCards from './screens/AccountCards/AccountCards'
import Resources from './screens/Resources/Resources'
import {Route, Routes, useNavigate} from 'react-router-dom'
import { useState } from 'react';
import PrivateRoute from './util/PrivateRoute';

function App() {

  const [isAuthenticated, setAuthenticated] = useState(false)

  const navigation=useNavigate()
  return (
    <div className="container">
      <Routes>
        <Route path="/" element={<Login navigator={navigation} setAuth={setAuthenticated} />} />
        <Route path="/Login" element={<Login navigator={navigation} setAuth={setAuthenticated} />} />
        <Route path='/Dashboard' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <Dashboard navigator={navigation}/>
          </PrivateRoute>
        }/>
        <Route path='/Account/Activity' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <AccountActivity navigator={navigation}/>
          </PrivateRoute>
         }/>
        <Route path='/Account/Management' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <AccountManagement navigator={navigation}/>
          </PrivateRoute>
        }/>
        <Route path='/Account/Cards' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <AccountCards navigator={navigation}/>
          </PrivateRoute>
        }/>
        <Route path='/Claims/SubmitExpense' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <SubmitExpense navigator={navigation}/>
          </PrivateRoute>
        }/>
        <Route path='/Resources' element={
          <PrivateRoute isAuthenticated={isAuthenticated}>
            <Resources navigator={navigation}/>
          </PrivateRoute>
        }/>
      </Routes>
    </div>
  );
}

export default App;
